import React, { Component } from 'react';
import Footer from '../../components/Footer';
import Signup from './../../components/Signup';
import './styles.scss';

const Registration = props => {
  return (
    <>
      <Signup />
      <Footer/>
    </>
  );
};

export default Registration;
